import React from 'react'
import { StylesSpinnerProps } from './styles'
import logo from '../../assets/images/logo-inlog.png'
import { Box, CircularProgress, Typography } from '@mui/material'

interface ExtendedStylesSpinnerProps extends StylesSpinnerProps {
  isDifferenceDate?: boolean
}

const LoadingReportGeneration: React.FC<ExtendedStylesSpinnerProps> = ({
  isDifferenceDate = false
}) => {
  return (
    <Box
      sx={{
        p: 2,
        gap: 3,
        position: 'fixed',
        left: 0,
        top: 50,
        minWidth: '100vw',
        backgroundColor: '#fff',
        zIndex: 999
      }}
      className="container d-flex flex-column justify-content-center align-items-center vh-100"
    >
      <CircularProgress />
      <img src={logo} alt="logo" width="150" />
      <div className="d-flex align-items-center mb-2 gap-3">
        <Typography variant="h5">Gerando relatório</Typography>
      </div>
      {isDifferenceDate && (
        <div className="d-flex align-items-center mb-2 gap-3">
          <Typography variant="caption">
            O filtro para um período longo pode demorar um pouco. Por favor,
            aguarde.
          </Typography>
        </div>
      )}
    </Box>
  )
}

export default LoadingReportGeneration
